import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as HMS from "../../../common/component/Index";
import Model from '../../../../../constants/Model';
import moment from 'moment';
import * as OrderComponent from "./CommonComponent";
import { Skeleton } from 'antd';
import FlightDetail from '../OrderDetail/FlightDetail';

class OrderDetailVoucher extends Component {
    state = {
        titleOrderItemTable: Func.getTitleTable(Model.OrdersModel.titleOrderDetailVoucher, ['totalPrice', 'action'], ['orderId', 'groupId', 'productVariantId', 'voucherType',]),
        modelOrderItem: Model.OrdersModel.titleOrderDetailVoucher,
        componentTable: {
            totalPrice: {
                width: 100,
                render: (text, record) => {
                    return record.originalPrice || '-'
                },
            },
            action: {
                width: 100,
                render: (text, record) => <OrderComponent.ShowDetailGroupComponent item={record}
                    onShowDetailGroupVoucher={(i) => this.onShowDetailGroupVoucher(i)} />,
            }
        },
        data: {},
        infoDetailGroup: {},
        listVoucher: { orders: [] },
        isFetchingList: false,
        isUpload: false,
        showDetailGroupVoucher: false,
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.orders.dataDetail) {
            this.setState({
                isFetchingList: nextProps.orders.isFetching,
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.orders.listVoucher !== prevProps.orders.listVoucher) {
            this.setState({
                listVoucher: {
                    orders: this.props.orders.listVoucher.result,
                    pageSize: this.props.orders.listVoucher.pageSize,
                    pageIndex: this.props.orders.listVoucher.pageIndex,
                    totalCount: this.props.orders.listVoucher.totalCount,
                    totalPage: Math.ceil(parseInt(this.props.orders.listVoucher.totalCount) / parseInt(this.props.orders.listVoucher.pageSize))
                }
            })
        }
        if (this.props.orders.infoDetailGroup !== prevProps.orders.infoDetailGroup) {
            this.setState({
                infoDetailGroup: this.props.orders.infoDetailGroup
            })
        }
    }

    onShowDetailGroupVoucher = (e) => {
        this.setState({
            showDetailGroupVoucher: true,
            orderId: e.id,
            groupId: e.filters.groupId
        });
        this.props.onGetDetailVoucher(e)
    };

    onPaginateDetailGroup = (e) => {
        this.props.onGetDetailVoucher({
            id: this.state.orderId,
            filters: {
                ...e,
                groupId: this.state.groupId
            }
        })
    };

    render() {
        const { t } = this.props.props;
        const { data, isFetching } = this.props;
        const { componentTable, titleOrderItemTable, modelOrderItem, showDetailGroupVoucher, listVoucher, infoDetailGroup } = this.state;
        return (
            <Fragment>
                {
                    showDetailGroupVoucher && (
                        <OrderComponent.DetailOrderGroupVoucher
                            // isSubmit={isSubmit}
                            // data={data}
                            listVoucher={listVoucher}
                            isFetching={this.props.orders.isFetching}
                            onClose={(i) => this.setState({ showDetailGroupVoucher: i })}
                            onChange={(e) => this.onPaginateDetailGroup(e)}
                            // onSubmitUse={this.onSubmit}
                            // onSubmit={this.onSubmit}
                            showDetailGroupVoucher={showDetailGroupVoucher}
                        />
                    )
                }
                <HMS.LoadingComponent spinning={this.props.orders.isFetching} size={'large'}>
                    <HMS.PageListComponent>
                        <HMS.FormActionComponent
                            findParentRoute={() => Func.findParentRoute('orders', this.props.props)}
                            disableButtonSubmit={true}
                            submitButtonRight={true}>
                            <div className={`col-md-5`}>
                                <h3 className={`ml-3`}>{t('item.order.orderInfo')}</h3>
                                <div className={`row mt-2 fs14 order-item`}>
                                    <HMS.FormWrapperItem>
                                        {Object.keys(infoDetailGroup).length > 0 ?
                                            <ul className={`mb-0`}>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.orderCode')}:</span> {infoDetailGroup.orderCode}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.fullname')}:</span> {infoDetailGroup.fullname}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.phoneNumber')}:</span> {infoDetailGroup.phoneNumber}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.email')}:</span> {infoDetailGroup.email}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.createdDate')}:</span> {moment(infoDetailGroup.createdDate).format('DD-MM-YYYY hh:mm')}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.subTotal')}:</span> {Func.formatMoney(infoDetailGroup.subTotal)}
                                                    </div>
                                                </li>
                                                <li>
                                                    <div className={`col-md-12 mb-3 pl-0`}>
                                                        <span
                                                            className={`semi-bold`}>{t('item.order.status')}:</span> {infoDetailGroup.status == 2 ? i18n.t('item.order.paid') : i18n.t('item.order.unpaid')}
                                                    </div>
                                                </li>
                                            </ul>
                                            : <Skeleton active paragraph={{ rows: 7 }}  className="p-2"/>
                                        }
                                    </HMS.FormWrapperItem>
                                </div>
                            </div>
                            <div className={`col-md-7`}>
                                <h3 className={`ml-3`}>{t('item.order.orderItemInfo')}</h3>
                                <HMS.ListComponent
                                    classParent={`order-item`}
                                    rowKey={(record, k) => k}
                                    dataSource={Func.getDataSource(data.orders, modelOrderItem)}
                                    columns={Func.columnsTable({
                                        titleTable: titleOrderItemTable,
                                        component: componentTable,
                                        itemName: 'order.voucher'
                                    })}
                                    pagination={{ total: data.orders.totalCount, totalPage: data.orders.totalPage }}
                                    componentTableList={{}}
                                />
                            </div>

                            {this.props.flightInfos}
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        orders: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListOrder: (filters) => {
            dispatch(action.dataOrderAction(filters))
        },
        onGetDetailVoucher: (params) => {
            dispatch(action.getDetailVoucherOrderAction(params))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderDetailVoucher));
